import { useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import IconButton from '@mui/material/IconButton';
import DataArrayRoundedIcon from '@mui/icons-material/DataArrayRounded';
import MenuList from '@components/MenuList';
import Tooltip from '@components/Tooltip';
import { useTranslation } from '@hooks';
import { PLACEHOLDER_CONTEXT, getPlaceholdersForContext } from '@constants/placeholders';

// The plain-input sibling of @features/PostDynamicVariables: same in-field trigger and menu,
// but inserts `[token]` markers through a callback instead of a TipTap editor.
const DynamicFieldsButton = ({ onInsert, disabled, formatToken = token => `[${token}]`, btnStyles = {} }) => {
    const isMobile = useMediaQuery('@media (max-width: 600px)');
    const [anchorEl, setAnchorEl] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const { t } = useTranslation();

    const handleOpen = event => {
        if (isMobile) {
            setOpenModal(true);
        } else {
            setAnchorEl(event.currentTarget);
        }
    };

    const handleClose = () => setAnchorEl(null);
    const handleCloseModal = () => setOpenModal(false);

    const options = getPlaceholdersForContext(PLACEHOLDER_CONTEXT.CAMPAIGN).map(({ labelKey, token }) => ({
        icon: null,
        text: t(labelKey),
        sub: {},
        onClick: () => {
            onInsert(formatToken(token));
            handleClose();
            handleCloseModal();
        },
    }));

    return (
        <MenuList
            options={options}
            anchorEl={anchorEl}
            onCloseMenu={handleClose}
            openModal={openModal}
            handleCloseModal={handleCloseModal}
            mainTitle={t('PostDynamicVariables.title')}
            menuButton={
                <Tooltip title={t('PostDynamicVariables.title')} placement="top">
                    <IconButton
                        size="small"
                        color="inherit"
                        onClick={handleOpen}
                        disabled={disabled}
                        aria-label={t('PostDynamicVariables.title')}
                        sx={{
                            padding: '4px',
                            '& svg': {
                                color: 'var(--text-secondary)',
                                fontSize: 18,
                            },
                            ...btnStyles,
                        }}
                    >
                        <DataArrayRoundedIcon />
                    </IconButton>
                </Tooltip>
            }
        />
    );
};

export default DynamicFieldsButton;
